import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableDebeFormGroup = ({ iError, iTouched, iValue, values, setValues }) => {
  const onChange = React.useCallback(
    salida => {
      values.cuentaContableDebe = salida.value
      values.cuentaContableDebeInfo = salida.label
      values.cuentaContableDebeTipoDocumento = salida.tipoDocumento
      values.flagCentroCostoCuentaContableDebe = salida.flagCentroCosto
      values.esCuentaActivoFijoCuentaContableDebe = salida.esActivoFijo
      values.tipoSocioCuentaContableDebe = salida.tipoSocio

      if (!salida.value.startsWith('6') && !salida.value.startsWith('9')) {
        values.tipoAfectacionCuentaContableDebe = ''
      }

      setValues(values)

      setTimeout(() => {
        KeyEventUtil.leaveOnKeyEvent(`select2-entregaARenidr-trabajador`)
      }, 200)
    },
    [values, setValues]
  )

  const clickClear = React.useCallback(() => {
    values.cuentaContableDebe = ''
    values.cuentaContableDebeInfo = ''
    values.cuentaContableDebeTipoDocumento = ''
    values.flagCentroCostoCuentaContableDebe = false
    values.esCuentaActivoFijoCuentaContableDebe = false
    values.tipoSocioCuentaContableDebe = ''
    values.tipoAfectacionCuentaContableDebe = ''

    setValues(values)

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select-entregaARenidr-cuentaContableDebe`)
    }, 200)
  }, [values, setValues])

  React.useEffect(() => {
    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select-entregaARenidr-cuentaContableDebe`)
    }, 200)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='CUENTA DEBE' htmlFor='select-entregaARenidr-cuentaContableDebe' md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='clearinput-entregaARenidr-cuentaContableDebe' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-entregaARenidr-cuentaContableDebe' onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableDebeFormGroup)
